module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAAAXNSR0IArs4c6QAAARJJREFUOE+l0j0vBFEUxvH/MzvJolDoJBpRqSmURIgvIRGSTWYaOjovlUKzDbNTeWn0CtGwlWqj9gFEh0QkrM3skZVN7Ax3Jrjlved3z0uOKjUb88UZMM7P57CdcCSPVRKWD0I9KYitIZhwgM71J/JKXAE3zRfmFMZmOQAzTvHYk9Hoxl0XI3h8fmN00GfaxFAHFqLu7/cYVYyH36BUB72ZmsBrTn/9QDmVqZ0wEwWqu1AY2QIe59ny1vYrqrpQENu6YDeFDExG4kImSgL9fxAGO+8tTlyZyj4riI3sIGajQJfOQdRsHnGRLe/Ovlblm5WYBEb+3lMQ27FgMW9pe98M6lrasr6BYTZNTBVBwS0ttj8A6jV4iUlGwSIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home1.png
// module id = 9UFW
// module chunks = 20